import React,{useState, useEffect} from 'react';
import "./css/AdminProduct.css";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { firestore } from '../firebase';

function CustomerProduct({data}) {
    const [statusFilter, setStatusFilter] = useState('');

const cancelOrder = async () => {
  try {
    if (data?.name) {
      const orderId = `${data.name}_${data.orderId || ''}`;

      const orderRef = firestore.collection('orders').doc(orderId);

      await orderRef.update({ status: 'Canceled' });
      alert('Order Canceled');
    }
  } catch (error) {
    console.error('Error updating status:', error);
    alert('Failed to cancel order');
  }
};
  return (
    <div className='admin-product'>
        <Link to={`/product-details/${data?.itemOrdered}`}>
        <img src={data?.image} alt={data?.itemOrdered} />
      <div className="product_info">
        <p style={{textAlign: "center"}}>{data?.itemOrdered}</p>
        <div className="product_price">
          <p style={{textAlign: "center"}}>${data?.price} <br />
          Status: {data?.status}
          </p>
        </div>
      </div>
      </Link>
      <p style={{textAlign: "center"}}><button onClick={cancelOrder}>Cancel Order</button></p>
    </div>
  )
}

export default CustomerProduct